"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Drawer_1 = require("./Drawer");
const CartContent_1 = require("@components/pages/cart/CartContent");
const LabelContext_1 = require("@components/common/context/LabelContext");
const CartDrawer = ({ labels, className, icon, label, anchor }) => (React.createElement(Drawer_1.default, { className: className, icon: icon, label: label, anchor: anchor },
    React.createElement(CartContent_1.default, { title: labels.MY_CART, totalTextlabel: labels.CART_TOTAL, showSubtotal: true })));
exports.default = LabelContext_1.withLabel(CartDrawer);
